import React from 'react';

import { CssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { useAppTheme } from 'src/hooks/app';

import { ThemeLoader } from '../ThemeLoader';

export const ThemeWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { appTheme, themeWasChanged, setThemeWasChanged } = useAppTheme();
  const [isRepainting, setIsRepainting] = React.useState(false);

  React.useEffect(() => {
    if (themeWasChanged) {
      setIsRepainting(true);
      setThemeWasChanged(false);

      setTimeout(() => {
        setIsRepainting(false);
      }, 2000);
    }
  }, [appTheme, themeWasChanged, setThemeWasChanged]);

  if (isRepainting) {
    return <ThemeLoader />;
  }

  return (
    <MuiThemeProvider theme={appTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
